// Allow injecting a Sentry instance for Node.js environments
let sentryInstance = null;
export var Sentry;
(function (Sentry_1) {
    /** Set the Sentry instance (for Node.js apps using @sentry/node) */
    function setInstance(sentry) {
        sentryInstance = sentry;
    }
    Sentry_1.setInstance = setInstance;
    function getSentry() {
        if (sentryInstance)
            return sentryInstance;
        if (typeof window !== "undefined")
            return window.Sentry;
        return null;
    }
    function captureException(error, options = {}) {
        const Sentry = getSentry();
        if (Sentry) {
            Sentry.captureException(error, {
                tags: {
                    ...options.tags,
                    "client.version": "new_restaumatic_client",
                },
                level: options.level,
                extra: options.extra,
            });
        }
    }
    Sentry_1.captureException = captureException;
    function logError(error, options = {}) {
        captureException(error, { ...options, level: "log" });
    }
    Sentry_1.logError = logError;
    // Tag shape must match the higgs/pendolino backends (pendolino
    // config/initializers/sentry.rb) so Sentry issues cross-link by trace_id.
    // The signoz deep-link tag is added backend-side only — we don't ship the
    // internal SigNoz URL in public client bundles.
    function setTrace(traceId, spanId) {
        var _a, _b;
        const Sentry = getSentry();
        if (!Sentry)
            return;
        (_a = Sentry.setTag) === null || _a === void 0 ? void 0 : _a.call(Sentry, "trace_id", traceId);
        (_b = Sentry.setContext) === null || _b === void 0 ? void 0 : _b.call(Sentry, "trace", { trace_id: traceId, span_id: spanId });
    }
    Sentry_1.setTrace = setTrace;
})(Sentry || (Sentry = {}));
